
import { Vue, Component, Prop } from "vue-property-decorator";
import UIButton from "@/components/button/ui-button.vue";
import { NOTIFICATION } from "@/entities/Events";
import Message from "@/data/notificationsMessages";
import { inviteContractors } from "@/services/inviteContractorsMarketPlace";
import Roles from "@/entities/Roles";

import APPROVE_PUBLIC_CONTRACTOR from "@/apollo/jobboard/ApprovePublicContractor.gql";

@Component({
  components: {
    UIButton,
  },
})
export default class AddContractorToCompany extends Vue {
  @Prop({ type: String, required: true }) readonly companyId!: string;
  @Prop({ type: String, required: true }) readonly companyName!: string;
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
  @Prop({ type: String, default: undefined }) readonly currentUserRole?: string;
  @Prop({ type: String, default: undefined }) readonly buttonClasses?: string;
  @Prop({ type: String, required: true }) readonly contractorUserId!: string;
  @Prop({ type: String, default: "Add to Company" }) readonly buttonText!: string;
  @Prop({ type: String, default: undefined }) readonly buttonVariant!: string;
  @Prop({ type: String, default: undefined }) readonly buttonSize!: string;
  @Prop({ type: Boolean, default: false }) readonly fullWidth!: boolean;
  @Prop({ type: Boolean, default: false }) readonly isPublic!: boolean;

  processing: boolean = false;

  get isCurrentUserAdmin(): boolean {
    return this.currentUserRole === Roles.ADMIN;
  }

  async add(): Promise<void> {
    this.processing = true;
    try {
      if (this.isCurrentUserAdmin) {
        this.$confirm({
          title: `Add Contractor to Company`,
          message: `Are you sure?`,
          button: {
            no: "No",
            yes: "Yes",
          },
          callback: async (confirm: any) => {
            if (confirm) {
              await this.addNewContractorToCompany();
              this.$emit("addedToCompany");
            }
          },
        });
        return;
      }
      await this.addNewContractorToCompany();
      this.$emit("addedToCompany");
      if (this.isPublic) {
        try {
          await this.$apollo.mutate({
            mutation: APPROVE_PUBLIC_CONTRACTOR,
            variables: {
              contractorUserId: this.contractorUserId,
              managerUserId: this.currentUserId,
            },
          });
          this.$root.$emit("refetch");
        } catch (ee) {
          this.$eventBus.emit(NOTIFICATION, Message.errorMessage(ee.message));
        }
      }
    } catch (e) {
      this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
    } finally {
      this.processing = false;
    }
  }

  async addNewContractorToCompany() {
    await inviteContractors({
      users: [
        {
          user_id: this.contractorUserId,
        },
      ],
      companyId: this.companyId,
      companyBusinessName: this.companyName ?? "",
      invitedByUserId: this.currentUserId,
    });
  }
}
